"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AutoRichtigWaschenUndPflegen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Auto richtig waschen & pflegen – der große Pflegeleitfaden"
        link="/guides/auto-richtig-waschen-und-pflegen"
        linkname="Autopflege"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="In welcher Reihenfolge sollte man ein Auto waschen?"
              leftText={
                <>
                  <p>
                    Wer sein Auto pflegt, profitiert mehrfach: Ein sauberes
                    Fahrzeug ist nicht nur ein schöner Anblick, sondern behält
                    auch länger seinen Wert. Schmutz, Streusalz und
                    Sonneneinstrahlung greifen auf Dauer Lack und Innenraum an.
                    Eine regelmäßige Pflege schützt vor Rost, verhindert Kosten
                    und sorgt dafür, dass das Auto beim Verkauf einen besseren
                    Eindruck macht. In diesem umfassenden Leitfaden erklären wir
                    dir Schritt für Schritt, wie du dein Auto von außen und innen
                    richtig reinigst und pflegst, welche Produkte sich eignen,
                    welche Fehler du vermeiden solltest und welche gesetzlichen
                    Regeln es zu beachten gibt.
                  </p>

                  <h3>Außenreinigung – Schritt für Schritt</h3>
                  <ol className="custom-ordered-list">
                    <li>
                      <strong>Vorwäsche</strong>
                      <br />
                      Bevor du Hand anlegst, spüle dein Auto gründlich mit
                      klarem Wasser ab. Das entfernt Staub, Salz und grobe
                      Schmutzpartikel, die beim Wischen sonst wie Schmirgelpapier
                      wirken. Nutze dafür eine Waschbox oder einen
                      Hochdruckreiniger. Achte auf einen ausreichenden Abstand
                      (mindestens 30 cm), damit der Lack nicht beschädigt wird.
                    </li>
                    <li>
                      <strong>Shampoo und Schwamm</strong>
                      <br />
                      Verwende ausschließlich speziell für Autos entwickelte
                      Shampoos. Haushaltsreiniger sind aggressiv und entziehen
                      dem Lack Schutzschichten. Arbeite mit einem weichen Schwamm
                      oder Waschhandschuh und teile das Auto in Abschnitte ein:
                      erst Dach, dann Motorhaube, Heck, Türen und Schürzen. Spüle
                      Schwamm und Eimer regelmäßig aus, um Schmutzpartikel zu
                      entfernen. Für empfindliche Bereiche wie verchromte
                      Zierleisten gibt es spezielle Pflegemittel.
                    </li>
                    <li>
                      <strong>Felgen & Radkästen</strong>
                      <br />
                      Felgen sind besonders anfällig für hartnäckigen Bremsstaub.
                      Nutze Felgenreiniger, der den Schmutz anlöst, und einen
                      separaten Bürstenaufsatz. Radkästen können mit dem
                      Hochdruckreiniger ausgespült werden; vermeide jedoch,
                      elektronische Bauteile direkt anzustrahlen.
                    </li>
                    <li>
                      <strong>Abspülen und Trocknen</strong>
                      <br />
                      Spüle das Fahrzeug gründlich ab, um alle Shampoo-Rückstände
                      zu entfernen. Trockne es anschließend mit einem sauberen
                      Mikrofasertuch oder einem Lederlappen. Trocknen ist
                      wichtig, um Wasserflecken zu vermeiden. Achte auf versteckte
                      Wasseransammlungen (z. B. Spiegelgehäuse) und wische sie
                      nach.
                    </li>
                    <li>
                      <strong>Lackschutz auftragen</strong>
                      <br />
                      Nach der Wäsche empfiehlt es sich, eine Wachsschicht oder
                      ein Lackversiegelungsprodukt aufzutragen. Diese schützen
                      den Lack vor UV-Strahlen, saurem Regen und Verschmutzung.
                      Wachs kann manuell aufgetragen und mit Polierpads
                      eingearbeitet werden. Versiegelungen halten länger, kosten
                      aber mehr.
                    </li>
                  </ol>

                  <h3>Pflege von Kunststoff- und Gummiteilen</h3>
                  <p>
                    Stoßfänger, Zierleisten und Türdichtungen altern durch
                    Witterungseinflüsse. Nutze spezielle Kunststoffpflegemittel,
                    die Feuchtigkeit spenden und vor UV-Strahlung schützen.
                    Gummidichtungen mit Glycerin oder Silikon pflegen – das
                    verhindert, dass sie porös werden und im Winter festfrieren.
                    Vermeide ölhaltige Produkte im Motorraum, da sie Staub
                    anziehen.
                  </p>

                  <h3>Fenster und Spiegel</h3>
                  <p>
                    Für klare Sicht innen wie außen eignet sich Glasreiniger
                    ohne Ammoniak, damit Plastikteile nicht angegriffen werden.
                    Reinige die Scheiben kreuzweise und trockne mit einem
                    fusselfreien Tuch nach. Hartnäckige Insektenreste löst ein
                    Insektenentferner. Klebereste von Vignetten erwärmst du mit
                    einem Föhn und rubbelst sie mit einem Plastikschaber ab, um
                    Kratzer zu vermeiden.
                  </p>

                  <h3>Innenreinigung – gepflegtes Ambiente</h3>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Staubsaugen:</strong> Sauge Sitzflächen, Teppiche,
                      Fußmatten und Zwischenräume gründlich aus. Hebe die
                      Teppiche an und reinige auch darunter.
                    </li>
                    <li>
                      <strong>Armaturenbrett und Kunststoff:</strong> Nutze einen
                      milden Cockpitreiniger. Vermeide fettige Mittel, die einen
                      glänzenden Film hinterlassen und Staub anziehen.
                    </li>
                    <li>
                      <strong>Polster:</strong> Verwende Polsterschaum und eine
                      weiche Bürste. Bearbeite Flecken vorsichtig, um Gewebe
                      nicht zu beschädigen.
                    </li>
                    <li>
                      <strong>Ledersitze:</strong> Lederreinigungsmittel und
                      Pflegemilch halten das Material geschmeidig. Pflege das
                      Leder zweimal jährlich, damit es nicht austrocknet oder
                      reißt.
                    </li>
                    <li>
                      <strong>Klimaanlage:</strong> Eine desinfizierende
                      Behandlung verhindert Geruch und Schimmel. Sprays gibt es
                      im Handel; professionelle Reinigungen dauern länger, sind
                      aber gründlicher.
                    </li>
                  </ul>

                  <h3>Motorraum reinigen</h3>
                  <p>
                    Der Motorraum sollte nur bei starker Verschmutzung gereinigt
                    werden. Decke empfindliche Bauteile wie Lichtmaschine,
                    Steuergeräte und Sicherungskästen ab. Sprühe den Motor mit
                    einem fettlösenden Reiniger ein, lasse ihn einwirken und spüle
                    vorsichtig mit wenig Wasser ab. Vermeide Hochdruckreiniger,
                    denn eindringende Feuchtigkeit kann Elektronik beschädigen.
                    Wische anschließend mit einem Mikrofasertuch nach.
                  </p>
                </>
              }
              rightFirstTitle="Gesetzliche Regelungen"
              rightFirstText={
                <>
                  <p>
                    In vielen Gemeinden ist die Autowäsche zuhause nur
                    eingeschränkt erlaubt, weil das Abwasser ins Grundwasser
                    gelangen kann. Die Bußgelder sind hoch. Nutze deshalb
                    Waschboxen oder Waschanlagen. Diese verfügen über
                    Auffangsysteme, die Chemikalien filtern.
                  </p>
                </>
              }
              rightSecondTitle="Tipps für die Werterhaltung"
              rightSecondText={
                <>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Regelmäßigkeit:</strong> Wasche dein Auto je nach
                      Nutzung etwa alle zwei Wochen. Häufigere Wäschen im Winter
                      verhindern Salzschäden.
                    </li>
                    <li>
                      <strong>Konservierung:</strong> Eine zweimal jährliche
                      Politur und Versiegelung schützt dauerhaft.
                    </li>
                    <li>
                      <strong>Innenraumklima:</strong> Lüfte und heize den
                      Innenraum regelmäßig, um Feuchtigkeit und Schimmel zu
                      verhindern.
                    </li>
                    <li>
                      <strong>Garage:</strong> Ein Stellplatz schützt vor
                      Witterung und verlängert die Lebensdauer von Lack und
                      Kunststoff.
                    </li>
                  </ul>
                </>
              }
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Autopflege"
                kaputtesAuto
                unfallAuto
                autoExport
                autoVerkaufen
                autoBewerten
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Auto waschen und pflegen"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Die richtige Autopflege ist keine Wissenschaft, erfordert
                      aber Zeit und Sorgfalt. Mit hochwertigen Reinigungsmitteln,
                      der passenden Technik und der Beachtung gesetzlicher
                      Vorgaben erhältst du den Glanz deines Fahrzeugs und steigerst
                      seinen Wiederverkaufswert. Ein gepflegtes Auto ist die beste
                      Visitenkarte – sowohl im Alltag als auch beim Verkauf. Wenn
                      du dein Auto nach der gründlichen Pflege verkaufen möchtest,
                      sorgt Autoeinfachlos für einen schnellen und fairen Abschluss.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AutoRichtigWaschenUndPflegen;

